<template>
  <v-row>
    <v-col cols="12">
      <v-card tile flat color="transparent">
        <v-card-title class="px-0 pt-0">
          <v-row align="center">
            <v-col>
              <div class="headline">Projects</div>
            </v-col>

            <v-col>
              <v-row>
                <v-spacer></v-spacer>
                <v-col>
                  <v-text-field
                    label="search"
                    outlined
                    filled
                    dense
                    hide-details="true"
                    v-model="search"
                    background-color="#fff"
                  ></v-text-field>
                </v-col>
                <v-col cols="auto" v-if="$can('projects.create')">
                  <project-create-modal
                    color="secondary"
                    depressed
                    height="40"
                  ></project-create-modal>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-fade-transition mode="out-in">
            <v-row v-if="loading.projects" key="1">
              <v-col cols="4" v-for="index in 6" :key="index">
                <v-card outlined>
                  <v-skeleton-loader
                    type="table-heading, list-item-two-line"
                  ></v-skeleton-loader>
                </v-card>
              </v-col>
            </v-row>

            <v-fade-transition
              group
              tag="div"
              class="row"
              v-else-if="filteredProjects.length"
              key="2"
              mode="in-out"
              leave-absolute
            >
              <v-col
                cols="4"
                v-for="project in filteredProjects"
                :key="project.id"
              >
                <v-card
                  width="100%"
                  height="100%"
                  outlined
                  :to="{ name: 'project', params: { project_id: project.id } }"
                >
                  <v-card-title>{{ project.name }}</v-card-title>

                  <v-card-text>
                    <div class="body-1">Customer</div>
                    <div class="body-2 mb-3">
                      {{ project.customer.name }}
                    </div>

                    <div class="body-1">Members</div>
                    <div class="body-2">
                      {{ getMemberNames(project.members) }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-fade-transition>

            <v-row v-else key="3">
              <v-col cols="12">
                <v-card width="100%" outlined>
                  <v-card-text>
                    <div class="title">No projects found.</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-fade-transition>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProjectCreateModal from '@/components/projects/ProjectCreateModal'

export default {
  name: 'Projects',
  data: () => ({
    search: ''
  }),
  components: {
    ProjectCreateModal
  },
  computed: {
    ...mapGetters('projects', ['projects', 'loading']),
    filteredProjects() {
      let regex = new RegExp(this.search, 'i')

      return this.projects.filter(({ name }) => name.match(regex)) || []
    }
  },
  methods: {
    ...mapActions('projects', ['fetchProjects']),
    getMemberNames(members) {
      let memberNames = members.map(({ name }) => name)
      return memberNames.length ? memberNames.join(', ') : 'No members.'
    }
  },
  created() {
    this.fetchProjects()
  }
}
</script>
